/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMetierDto
 */
export interface UserMetierDto {
    /**
     * 
     * @type {number}
     * @memberof UserMetierDto
     */
    idmetier?: number;
    /**
     * 
     * @type {string}
     * @memberof UserMetierDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetierDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetierDto
     */
    stade?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserMetierDto
     */
    selected?: boolean;
}

/**
 * Check if a given object implements the UserMetierDto interface.
 */
export function instanceOfUserMetierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserMetierDtoFromJSON(json: any): UserMetierDto {
    return UserMetierDtoFromJSONTyped(json, false);
}

export function UserMetierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMetierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'stade': !exists(json, 'stade') ? undefined : json['stade'],
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
    };
}

export function UserMetierDtoToJSON(value?: UserMetierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idmetier': value.idmetier,
        'nom': value.nom,
        'code': value.code,
        'stade': value.stade,
        'selected': value.selected,
    };
}

